// Constant: Environment > API URL
const API_URL = window.env?.API_URL || process.env.REACT_APP_API_URL

// Constant: Environment > Authentication API URL
const AUTHENTICATION_API_URL = window.env?.AUTHENTICATION_API_URL || process.env.REACT_APP_AUTHENTICATION_API_URL

// Constant: Environment > Account data URL
const ACCOUNT_DATA_URL = `${AUTHENTICATION_API_URL}/auth/check`

// Constant: Environment > Admin dashboard URL
const ADMIN_DASHBOARD_URL = window.env?.ADMIN_DASHBOARD_URL || process.env.REACT_APP_ADMIN_DASHBOARD_URL

// Constant: Environment > Agent URL
const AGENT_URL = window.env?.AGENT_URL || process.env.REACT_APP_AGENT_URL

// Constant: Environment > Application URL path prefix
const APPLICATION_URL_PATH_PREFIX = window.env?.APPLICATION_URL_PATH_PREFIX || process.env.REACT_APP_APPLICATION_URL_PATH_PREFIX

// Constant: Environment > Bel Esprit URL
const BELESPRIT_URL = window.env?.BELESPRIT_URL || process.env.REACT_APP_BELESPRIT_URL

// Constant: Environment > Captcha v2 site key
const CAPTCHA_V2_SITE_KEY = window.env?.CAPTCHA_V2_SITE_KEY || process.env.REACT_APP_CAPTCHA_V2_SITE_KEY

// Constant: Environment > Captcha v3 site key
const CAPTCHA_V3_SITE_KEY = window.env?.CAPTCHA_V3_SITE_KEY || process.env.REACT_APP_CAPTCHA_V3_SITE_KEY

// Constant: Environment > Console URL
const CONSOLE_URL = window.env?.CONSOLE_URL || process.env.REACT_APP_CONSOLE_URL

// Constant: Environment > Data URL
const DATA_URL = `${API_URL}/graphql`

// Constant: Environment > Docs URL
const DOCS_URL = window.env?.DOCS_URL || process.env.REACT_APP_DOCS_URL

// Constant: Environment > Email builder URL
const EMAIL_BUILDER_URL = window.env?.EMAIL_BUILDER_URL || process.env.REACT_APP_EMAIL_BUILDER_URL

// Constant: Environment > Email validation check URL
const EMAIL_VALIDATION_CHECK_URL = `${AUTHENTICATION_API_URL}/register/check-email`

// Constant: Environment > Email verification code URL
const EMAIL_VERIFICATION_CODE_URL = `${AUTHENTICATION_API_URL}/register/confirmation/resend-code`

// Constant: Environment > Environment
const ENVIRONMENT = window.env?.ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT

// Constant: Environment > Fallback URL
const FALLBACK_URL = window.env?.FALLBACK_URL || process.env.REACT_APP_FALLBACK_URL

// Constant: Environment > Is live?
const IS_LIVE = ENVIRONMENT === 'test' || ENVIRONMENT === 'production'

// Constant: Environment > Is production?
const IS_PRODUCTION = ENVIRONMENT === 'production'

// Constant: Environment > Is on-premise?
const IS_ON_PREMISE = (window.env?.LOCATION || process.env.REACT_APP_LOCATION) === 'on-premise'

// Constant: Environment > Login URL
const LOGIN_URL = `${AUTHENTICATION_API_URL}/auth`

// Constant: Environment > Password change URL
const PASSWORD_CHANGE_URL = `${AUTHENTICATION_API_URL}/password/change`

// Constant: Environment > Password reset code URL
const PASSWORD_RESET_CODE_URL = `${AUTHENTICATION_API_URL}/password/reset-request`

// Constant: Environment > Password reset URL
const PASSWORD_RESET_URL = `${AUTHENTICATION_API_URL}/password/reset`

// Constant: Environment > Refresh URL
const REFRESH_URL = `${AUTHENTICATION_API_URL}/token/refresh`

// Constant: Environment > Registration URL
const REGISTRATION_URL = `${AUTHENTICATION_API_URL}/register`

// Constant: Environment > Single sign-on URL
const SINGLE_SIGN_ON_URL = `${AUTHENTICATION_API_URL}/oauth/token`

// Constant: Environment > SSO providers
const SSO_PROVIDERS = (window.env?.SSO_PROVIDERS || process.env.REACT_APP_SSO_PROVIDERS)?.replace(/\s/, 'g')?.split(',')

// Constant: Environment > SSO redirect URL
const SSO_REDIRECT_URL = window.env?.SSO_REDIRECT_URL || process.env.REACT_APP_SSO_REDIRECT_URL

// Constant: Environment > Store URL
const STORE_URL = window.env?.STORE_URL || process.env.REACT_APP_STORE_URL

// Constant: Environment > Studio URL
const STUDIO_URL = window.env?.STUDIO_URL || process.env.REACT_APP_STUDIO_URL

// Constant: Environment > Tag Manager ID
const TAG_MANAGER_ID = window.env?.TAG_MANAGER_ID || process.env.REACT_APP_TAG_MANAGER_ID

// Constant: Environment > Third-party registration URL
const THIRD_PARTY_AUTHENTICATION_URL = `${AUTHENTICATION_API_URL}/auth/external`

// Constant: Environment > Terms of service confirmation URL
const TERMS_OF_SERVICE_CONFIRMATION_URL = `${AUTHENTICATION_API_URL}/terms/accept`

// Constant: Environment > Two-factor authentication enabling URL
const TWO_FACTOR_AUTHENTICATION_ENABLING_URL = `${AUTHENTICATION_API_URL}/2fa/enable`

// Constant: Environment > Two-factor authentication QR code generation URL
const TWO_FACTOR_AUTHENTICATION_QR_CODE_GENERATION_URL = `${AUTHENTICATION_API_URL}/2fa/generate`

// Constant: Environment > Two-factor authentication validation URL
const TWO_FACTOR_AUTHENTICATION_VALIDATION_URL = `${AUTHENTICATION_API_URL}/2fa/validate`

// Constant: Environment > Verification URL
const VERIFICATION_URL = `${AUTHENTICATION_API_URL}/register/confirmation`

// Export
export {
	ACCOUNT_DATA_URL,
	ADMIN_DASHBOARD_URL,
	AGENT_URL,
	APPLICATION_URL_PATH_PREFIX,
	BELESPRIT_URL,
	CAPTCHA_V2_SITE_KEY,
	CAPTCHA_V3_SITE_KEY,
	CONSOLE_URL,
	DATA_URL,
	DOCS_URL,
	EMAIL_BUILDER_URL,
	EMAIL_VALIDATION_CHECK_URL,
	EMAIL_VERIFICATION_CODE_URL,
	ENVIRONMENT,
	FALLBACK_URL,
	IS_LIVE,
	IS_ON_PREMISE,
	IS_PRODUCTION,
	LOGIN_URL,
	PASSWORD_CHANGE_URL,
	PASSWORD_RESET_CODE_URL,
	PASSWORD_RESET_URL,
	REFRESH_URL,
	REGISTRATION_URL,
	SINGLE_SIGN_ON_URL,
	SSO_PROVIDERS,
	SSO_REDIRECT_URL,
	STORE_URL,
	STUDIO_URL,
	TAG_MANAGER_ID,
	TERMS_OF_SERVICE_CONFIRMATION_URL,
	THIRD_PARTY_AUTHENTICATION_URL,
	TWO_FACTOR_AUTHENTICATION_ENABLING_URL,
	TWO_FACTOR_AUTHENTICATION_QR_CODE_GENERATION_URL,
	TWO_FACTOR_AUTHENTICATION_VALIDATION_URL,
	VERIFICATION_URL
}
